module.exports = __webpack_public_path__ + "static/cashew_nuts_tieu_xanh_2-c778eb002190094b06a129ab12fa1186.jpg";